import type { Locale } from "@commerce-frontend/i18n/types";

export type Day =
	| "monday"
	| "tuesday"
	| "wednesday"
	| "thursday"
	| "friday"
	| "saturday"
	| "sunday";

export const days: Day[] = [
	"sunday", // sunday as first member, to enable getDay indexing
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday",
];

export const formatTime = (minutes: number, locale: Locale) => {
	const date = new Date();
	date.setHours(Math.floor(minutes / 60));
	date.setMinutes(minutes % 60);

	return date.toLocaleTimeString(locale, {
		hour: "2-digit",
		minute: "2-digit",
	});
};
